(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["description-product-and-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('show-more-less-content')) {
    class ShowMoreLessContent extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('#toggle-content');
        const contentEl = this.querySelector('#content');
        if (!contentEl) return;
        const fullHeight = contentEl.offsetHeight;
        const markReady = () => this.classList.add('ready');
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', markReady);
        } else {
          markReady();
        }

        let minHeight = this.getAttribute('min-height-mobile') ? this.getAttribute('min-height-mobile') - 20 : 0;
        if (window.screen.width > 767) {
          minHeight = this.getAttribute('min-height-desktop') ? this.getAttribute('min-height-desktop') - 20 : 0;
        }

        if (fullHeight > minHeight && minHeight > 0) {
          this.classList.add('toggle');
        }

        if (!button) return;
        button.addEventListener('click', this.toggleContent.bind(this));
      }

      toggleContent() {
        const contentEl = this.querySelector('#content');
        if (!contentEl) return;

        if (this.hasAttribute('open')) {
          if (contentEl.scrollHeight > 1000) {
            window.scrollTo({
              top: contentEl.getBoundingClientRect().top + window.scrollY - 100,
            });
          }
          if (contentEl.style.maxHeight === 'none') {
            contentEl.style.maxHeight = contentEl.scrollHeight + 'px';
          }
          const element = this;
          setTimeout(function () {
            element.removeAttribute('open');
            contentEl.style.maxHeight = 'revert-layer';
          }, 350);
        } else {
          this.setAttribute('open', '');
          contentEl.style.maxHeight = contentEl.scrollHeight + 'px';
          const element = this;
          contentEl.addEventListener('transitionend', function onEnd(event) {
            if (event.propertyName && event.propertyName !== 'max-height') return;
            contentEl.removeEventListener('transitionend', onEnd);
            if (element.hasAttribute('open')) {
              contentEl.style.maxHeight = 'none';
            }
          });
        }
      }
    }

    customElements.define('show-more-less-content', ShowMoreLessContent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('footer details[id^="Details-"] > summary').forEach((summary) => {
    const details = summary.parentElement;
    const panel = summary.nextElementSibling;

    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');
    if (panel && panel.id) summary.setAttribute('aria-controls', panel.id);

    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    details.addEventListener('keyup', (event) => {
      if (!event.code || event.code.toUpperCase() !== 'ESCAPE') return;
      const openDetails = event.target.closest('details[open]');
      if (!openDetails) return;
      const openSummary = openDetails.querySelector('summary');
      openDetails.removeAttribute('open');
      openSummary.setAttribute('aria-expanded', 'false');
      openSummary.focus();
    });
  });

  // Footer country select. A pick switches right away, so there is no confirm
  // button: `shop:` values leave for that country's own shop, `country:` values
  // are served by Europe and only change the Shopify Markets country.
  const countrySwitcher = document.querySelector('.js-footer-country-switcher');
  if (countrySwitcher) {
    const countrySwitcherForm = countrySwitcher.closest('form');
    const countryCodeInput = countrySwitcherForm
      ? countrySwitcherForm.querySelector('.js-footer-country-code')
      : null;
    const onEuropeShop = countrySwitcher.dataset.europeShop === 'true';

    // Same one-year shop preference the old footer flags wrote. The Europe
    // dialog reads it (snippets/shop-switcher.liquid), so a pick there also
    // stops it from asking again.
    const rememberShop = (value) => {
      document.cookie = `nailster_shop=${encodeURIComponent(value)}; Path=/; Max-Age=31536000; SameSite=Lax${
        window.location.protocol === 'https:' ? '; Secure' : ''
      }`;
    };

    countrySwitcher.addEventListener('change', () => {
      const value = countrySwitcher.value;
      const path = window.location.pathname || '/';

      if (value.indexOf('shop:') === 0) {
        const shop = value.slice(5);
        rememberShop(shop);
        window.location.assign(`https://nailster.${shop}${path}`);
        return;
      }

      if (value.indexOf('country:') !== 0) return;
      const country = value.slice(8);

      if (onEuropeShop && countrySwitcherForm && countryCodeInput) {
        rememberShop('com');
        countryCodeInput.value = country;
        countrySwitcherForm.submit();
        return;
      }

      // Only Europe can set its own Markets country, so hand the pick over in
      // the URL and let the switcher there apply it on arrival.
      window.location.assign(`https://nailster.com${path}?shop=com&country=${country}`);
    });

    // Enter inside the select would otherwise post an empty country.
    if (countrySwitcherForm) {
      countrySwitcherForm.addEventListener('submit', (event) => {
        if (!countryCodeInput || !countryCodeInput.value) event.preventDefault();
      });
    }
  }

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (!event.code || event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // =============================================
    // 1. HEADER HEIGHT
    //    Sets --header-h on :root so the drawer and search panel
    //    always sit right below the nav row. Recalculates on
    //    scroll (announcement bar disappears) and resize.
    // =============================================
    const navRow = document.querySelector('#shopify-section-header header > .page-width');
    const headerSection = document.getElementById('shopify-section-header');
    if (navRow) {
      let ticking = false;
      const syncHeaderH = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          document.documentElement.style.setProperty('--header-h', Math.round(navRow.getBoundingClientRect().bottom) + 'px');
          if (headerSection) {
            document.documentElement.style.setProperty('--header-full-h', Math.round(headerSection.getBoundingClientRect().bottom - 1) + 'px');
          }
        });
      };
      syncHeaderH();
      window.addEventListener('scroll', syncHeaderH, { passive: true });
      window.addEventListener('resize', syncHeaderH, { passive: true });
    }

    // =============================================
    // 2. ELEMENT REFERENCES
    // =============================================
    const ua = navigator.userAgent || '';
    const isMacSafari = /Macintosh|Mac OS X/i.test(ua)
      && navigator.maxTouchPoints <= 1
      && /AppleWebKit/i.test(ua)
      && !/Chrome|CriOS|Chromium|Edg|OPR|FxiOS/i.test(ua);
    if (isMacSafari) document.documentElement.classList.add('is-mac-safari');

    const menuContainer = document.querySelector('.js-main-menu-container');
    const openButton = document.querySelector('.js-main-menu-open');

    const mobileSearchBar = document.querySelector('.js-mobile-search-bar');
    const mobileSearchPanel = document.querySelector('.js-mobile-search-panel');
    // Outside <body> so the position:fixed scroll lock does not offset the overlay.
    if (mobileSearchPanel) document.documentElement.appendChild(mobileSearchPanel);
    const mobileSearchInput = mobileSearchPanel ? mobileSearchPanel.querySelector('.js-mobile-search-input') : null;
    const closeButtons = mobileSearchPanel ? mobileSearchPanel.querySelectorAll('.js-mobile-search-close') : [];
    const resetMobileMenuState = () => {
      if (!menuContainer) return;
      menuContainer.querySelectorAll('[data-mobile-hid="1"]').forEach(el => {
        el.classList.remove('tw:hidden');
        delete el.dataset.mobileHid;
      });
      menuContainer.querySelectorAll('details.js-mobile-subgroup[open]').forEach(d => { d.open = false; });
      menuContainer.querySelectorAll('details.js-mobile-dropdown[open]:not(.js-mobile-expanded)').forEach(d => { d.open = false; });
      menuContainer.querySelectorAll('.js-mobile-dropdown-children').forEach(children => {
        const navItem = children.closest('.js-nav-item');
        const parentDropdown = navItem && navItem.querySelector('details.js-mobile-dropdown');
        if (!parentDropdown || parentDropdown.classList.contains('js-mobile-expanded')) return;
        children.classList.add('tw:hidden');
      });
    };

    const resultsContainer = mobileSearchPanel ? mobileSearchPanel.querySelector('[data-predictive-search]') : null;

    const desktopSearchPanel = document.querySelector('.js-desktop-search-form');
    const desktopPredictiveSearch = desktopSearchPanel ? desktopSearchPanel.closest('predictive-search') : null;
    const desktopSearchInput = desktopSearchPanel ? desktopSearchPanel.querySelector('.js-header-search-input') : null;
    const desktopSearchResults = desktopPredictiveSearch ? desktopPredictiveSearch.querySelector('[data-predictive-search]') : null;

    // =============================================
    // 3. STATE (menu, search)
    // =============================================
    let isMenuOpen = false;
    let menuKeydownHandler = null;
    let menuPreviouslyFocusedElement = null;
    let searchKeydownHandler = null;
    let searchPreviouslyFocusedElement = null;
    let mobileSearchScrollY = 0;
    let mobileSearchScrollLocked = false;
    // =============================================
    // 4. HELPERS
    // =============================================

    // Toggle tw:hidden (used for the drawer which needs display:none)
    const showElement = (el) => { if (!el) return; el.classList.remove('tw:hidden'); };
    const hideElement = (el) => { if (!el) return; el.classList.add('tw:hidden'); };

    // Toggle opacity + pointer-events (used for the search panel).
    // The elements stay in the DOM so CSS transitions work naturally.
    const showPanel = (el) => { if (!el) return; el.classList.remove('tw:opacity-0', 'tw:pointer-events-none'); el.classList.add('tw:opacity-100', 'tw:pointer-events-auto'); };
    const hidePanel = (el) => { if (!el) return; el.classList.remove('tw:opacity-100', 'tw:pointer-events-auto'); el.classList.add('tw:opacity-0', 'tw:pointer-events-none'); };

    // Keep Tab key cycling inside a container; Escape calls onEscape
    const createTrapFocusHandler = (container, onEscape) => {
      const sel = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      return (e) => {
        if (e.key === 'Escape') { e.preventDefault(); if (typeof onEscape === 'function') onEscape(); return; }
        if (e.key === 'Tab') {
          const focusables = Array.from(container.querySelectorAll(sel)).filter(el => el.offsetParent !== null || el === document.activeElement);
          if (!focusables.length) return;
          if (e.shiftKey && document.activeElement === focusables[0]) { e.preventDefault(); focusables[focusables.length - 1].focus(); }
          else if (!e.shiftKey && document.activeElement === focusables[focusables.length - 1]) { e.preventDefault(); focusables[0].focus(); }
        }
      };
    };

    // On iOS, hide the keyboard when the user scrolls search results
    if (resultsContainer && mobileSearchInput) {
      const dismissKeyboard = () => { if (document.activeElement === mobileSearchInput) mobileSearchInput.blur(); };
      ['touchmove', 'scroll'].forEach(evt => resultsContainer.addEventListener(evt, dismissKeyboard, { passive: true }));
    }

    // =============================================
    // 5. MOBILE BURGER MENU
    //    Slides a full-screen drawer in from the left.
    //    Focus is trapped inside while open. Escape closes it.
    // =============================================
    const openMenu = () => {
      if (!menuContainer) return;
      resetMobileMenuState();
      showElement(menuContainer);
      isMenuOpen = true;
      menuContainer.style.willChange = 'transform';
      menuContainer.offsetWidth;
      requestAnimationFrame(() => { menuContainer.classList.remove('tw:-translate-x-full'); });
      if (openButton) {
        openButton.classList.add('is-open');
        openButton.setAttribute('aria-expanded', 'true');
        if (openButton.dataset.ariaOpen) openButton.setAttribute('aria-label', openButton.dataset.ariaOpen);
      }
      menuPreviouslyFocusedElement = document.activeElement;
      const focusable = menuContainer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (focusable.length) focusable[0].focus(); else menuContainer.focus();
      menuKeydownHandler = createTrapFocusHandler(menuContainer, () => closeMenu());
      document.addEventListener('keydown', menuKeydownHandler);
    };

    const closeMenu = () => {
      if (!menuContainer) return;
      menuContainer.classList.add('tw:-translate-x-full');
      if (openButton) {
        openButton.classList.remove('is-open');
        openButton.setAttribute('aria-expanded', 'false');
        if (openButton.dataset.ariaClosed) openButton.setAttribute('aria-label', openButton.dataset.ariaClosed);
      }
      setTimeout(() => {
        resetMobileMenuState();
        hideElement(menuContainer);
        menuContainer.style.willChange = '';
        if (menuKeydownHandler) { document.removeEventListener('keydown', menuKeydownHandler); menuKeydownHandler = null; }
        if (menuPreviouslyFocusedElement && typeof menuPreviouslyFocusedElement.focus === 'function') { menuPreviouslyFocusedElement.focus(); menuPreviouslyFocusedElement = null; }
        else if (openButton) { openButton.focus(); }
        isMenuOpen = false;
      }, 300);
    };

    if (openButton) openButton.addEventListener('click', () => { if (isMenuOpen) closeMenu(); else openMenu(); });

    // =============================================
    // 6. MOBILE SEARCH
    //    Full-screen panel with predictive results. Escape closes it.
    // =============================================
    // Mirror the live mobile search field into the collapsed bar label so the
    // committed/typed term stays visible. The server renders the initial term;
    // closePanel uses close(false) so the term survives panel close and back/forward.
    const mobileSearchBarLabel = mobileSearchBar ? mobileSearchBar.querySelector('.js-mobile-search-bar-label') : null;
    const syncMobileSearchBarLabel = () => {
      if (!mobileSearchBarLabel || !mobileSearchInput) return;
      const q = mobileSearchInput.value.trim();
      mobileSearchBarLabel.textContent = q || (mobileSearchBar.dataset.searchPlaceholder || '');
      mobileSearchBarLabel.classList.toggle('tw:text-gray-800', !!q);
      mobileSearchBarLabel.classList.toggle('tw:text-gray-500', !q);
    };

    const lockMobileSearchScroll = () => {
      if (mobileSearchScrollLocked) return;
      mobileSearchScrollLocked = true;
      mobileSearchScrollY = window.scrollY || window.pageYOffset || 0;
      const { style } = document.body;
      style.position = 'fixed';
      style.top = `-${mobileSearchScrollY}px`;
      style.left = '0';
      style.right = '0';
      style.width = '100%';
    };

    const unlockMobileSearchScroll = () => {
      if (!mobileSearchScrollLocked) return;
      mobileSearchScrollLocked = false;
      const { style } = document.body;
      style.position = '';
      style.top = '';
      style.left = '';
      style.right = '';
      style.width = '';
      // html has tw:scroll-smooth — disable it so restore is not an animated jump.
      const html = document.documentElement;
      const prev = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      window.scrollTo(0, mobileSearchScrollY);
      html.style.scrollBehavior = prev;
    };

    const openPanel = () => {
      if (!mobileSearchPanel) return;
      lockMobileSearchScroll();
      showPanel(mobileSearchPanel);
      searchPreviouslyFocusedElement = document.activeElement;
      if (mobileSearchInput) mobileSearchInput.focus({ preventScroll: true });
      try { if (resultsContainer) resultsContainer.scrollTop = 0; } catch (e) {}
      searchKeydownHandler = (e) => { if (e.key === 'Escape') { e.preventDefault(); closePanel(); } };
      document.addEventListener('keydown', searchKeydownHandler);
    };
    const closePanel = ({ restoreFocus = true } = {}) => {
      if (!mobileSearchPanel) return;
      hidePanel(mobileSearchPanel);
      unlockMobileSearchScroll();
      try { const ps = mobileSearchPanel.querySelector('predictive-search'); if (ps && typeof ps.close === 'function') ps.close(false); } catch (e) {}
      if (searchKeydownHandler) { document.removeEventListener('keydown', searchKeydownHandler); searchKeydownHandler = null; }
      if (restoreFocus && searchPreviouslyFocusedElement && typeof searchPreviouslyFocusedElement.focus === 'function') {
        searchPreviouslyFocusedElement.focus({ preventScroll: true });
        searchPreviouslyFocusedElement = null;
      } else searchPreviouslyFocusedElement = null;
    };
    document.addEventListener('slide-up-cart:open', () => {
      if (mobileSearchPanel && !mobileSearchPanel.classList.contains('tw:opacity-0')) {
        closePanel({ restoreFocus: false });
      }
      if (desktopPredictiveSearch && typeof desktopPredictiveSearch.close === 'function') {
        desktopPredictiveSearch.close(false);
      }
    });
    if (mobileSearchBar && mobileSearchPanel) {
      mobileSearchBar.addEventListener('click', (e) => { e.preventDefault(); if (mobileSearchPanel.classList.contains('tw:opacity-0')) openPanel(); });
    }
    if (mobileSearchPanel && closeButtons) {
      closeButtons.forEach(btn => btn.addEventListener('click', (e) => { e.preventDefault(); closePanel(); }));
    }

    if (mobileSearchInput) {
      mobileSearchInput.addEventListener('input', syncMobileSearchBarLabel);
      // The Clear button resets the form; onFormReset clears the value without
      // firing 'input', so re-sync the label after the reset settles.
      if (mobileSearchInput.form) mobileSearchInput.form.addEventListener('reset', () => requestAnimationFrame(syncMobileSearchBarLabel));
    }

    // =============================================
    // 7. DESKTOP SEARCH
    //    Closes the predictive results dropdown when clicking outside it.
    // =============================================
    if (desktopSearchResults) {
      document.addEventListener('click', (e) => {
        if (desktopPredictiveSearch && desktopPredictiveSearch.contains(e.target)) return;
        if (desktopPredictiveSearch && typeof desktopPredictiveSearch.close === 'function') desktopPredictiveSearch.close(false);
        else if (desktopSearchResults) desktopSearchResults.innerHTML = '';
      });
    }

    // =============================================
    // 8. DESKTOP MEGA MENU
    //    Each item is a wrapper with a collection link beside a <details>
    //    chevron (no nested interactive content). Click the link to go to
    //    the collection; the summary toggles the panel natively.
    //    JS adds hover open/close with a delay so the cursor can move
    //    from the trigger to the panel without it closing.
    //    Escape or clicking outside closes the open panel.
    // =============================================
    const megaTriggers = document.querySelectorAll('.js-mega-menu-trigger');
    const getMegaMenuItem = (trigger) => trigger.closest('.js-mega-menu-item') || trigger;
    const desktopMegaMenuMq = window.matchMedia('(min-width: 768px)');
    // Below lg Alle produkter scrolls — lock the page so scrollbars don't fight.
    const megaMenuScrollLockMq = window.matchMedia('(max-width: 1023px)');
    let activeMegaPanel = null;
    let megaHideTimeout = null;
    let megaShowTimeout = null;
    let megaHeightSyncFrame = null;
    let megaFeaturedReference = { productHeight: 0 };
    let megaMenuHeightBaseline = 0;
    let megaMenuHeightPrimed = false;
    const megaOpenDelayMs = 50;
    const megaCloseDelayMs = 280;

    const syncNavbarGroupFillPanelColumns = () => {
      document.querySelectorAll('.js-navbar-group-fill-panel').forEach(target => {
        target.style.setProperty('--menu-rows', '3');
      });
    };
    // Stable baseline from a set of sampled heights.
    const getMedianHeight = (heights) => {
      if (!heights.length) return 0;
      const sorted = heights.slice().sort((a, b) => a - b);
      return sorted[Math.floor(sorted.length / 2)];
    };
    // Product cards drive mixed-layout banner height.
    const getMaxProductCardHeight = (panel) => {
      const heights = Array.from(panel.querySelectorAll('.js-navbar-group-featured-card .js-product-card'))
        .map(card => Math.ceil(card.getBoundingClientRect().height))
        .filter(height => height > 0);
      return heights.length ? Math.max(...heights) : 0;
    };
    // Apply a single target height to banner wrappers (never exceed adjacent product cards).
    const setPanelBannerHeight = (panel, height) => {
      if (!height) return;
      const px = height + 'px';
      panel.querySelectorAll('.js-navbar-group-banner-card, .js-navbar-group-banner-inner').forEach(el => {
        el.style.height = px;
        el.style.maxHeight = px;
      });
    };
    const clearPanelBannerHeights = (panel) => {
      panel.querySelectorAll('.js-navbar-group-banner-card, .js-navbar-group-banner-inner').forEach(el => {
        el.style.removeProperty('height');
        el.style.removeProperty('max-height');
      });
    };
    // Temporarily open all desktop mega panels for consistent measurements.
    const withAllMegaPanelsOpen = (work) => {
      const triggerList = Array.from(megaTriggers);
      const previousOpenStates = triggerList.map(trigger => trigger.open);
      triggerList.forEach(trigger => { trigger.open = true; });
      try {
        work();
      } finally {
        triggerList.forEach((trigger, index) => { trigger.open = previousOpenStates[index]; });
      }
    };
    const getFeaturedPanelsByLayouts = (layouts) => Array.from(document.querySelectorAll(
      layouts.map(layout => `.js-navbar-group-featured-panel[data-featured-layout="${layout}"]`).join(', ')
    ));
    const isMixedFeaturedLayout = (layout) => layout === 'two-products-banner' || layout === 'one-product-banner';
    const isBannerOnlyFeaturedLayout = (layout) => layout === 'one-banner' || layout === 'two-banners';
    const getBannerBaselineHeight = ({ useCache = true } = {}) => {
      // Prefer cached full-measure height — closed panels report collapsed card heights.
      if (useCache && megaFeaturedReference.productHeight) return megaFeaturedReference.productHeight;
      const referenceHeights = getFeaturedPanelsByLayouts(['two-products-banner'])
        .map(getMaxProductCardHeight)
        .filter(height => height > 0);
      if (referenceHeights.length) return getMedianHeight(referenceHeights);
      const fallbackHeights = Array.from(document.querySelectorAll('.js-navbar-group-featured-card .js-product-card'))
        .map(card => Math.ceil(card.getBoundingClientRect().height))
        .filter(height => height > 0);
      return getMedianHeight(fallbackHeights);
    };
    // Mixed layouts follow local product-card height. Banner-only layouts use the shared baseline.
    const syncNavbarGroupBannerHeights = () => {
      const twoProductsPanels = getFeaturedPanelsByLayouts(['two-products-banner']);
      const oneProductPanels = getFeaturedPanelsByLayouts(['one-product-banner']);
      const twoBannerPanels = getFeaturedPanelsByLayouts(['two-banners']);
      const oneBannerPanels = getFeaturedPanelsByLayouts(['one-banner']);
      const mixedPanels = [...twoProductsPanels, ...oneProductPanels];
      const bannerOnlyPanels = [...twoBannerPanels, ...oneBannerPanels];
      const allPanels = [...mixedPanels, ...bannerOnlyPanels];

      allPanels.forEach(clearPanelBannerHeights);
      if (!desktopMegaMenuMq.matches) return;

      // Mixed layouts stretch the banner via the grid (no forced height); only banner-only
      // panels need a measured baseline since they have no product card to size against.
      // Safari skips opening panels, so closed cards measure empty — keep the cache there.
      // Other browsers remeasure with panels open and bypass the cache.
      const applyBannerHeights = ({ useCache = false } = {}) => {
        void document.documentElement.offsetHeight;
        const baselineHeight = getBannerBaselineHeight({ useCache });
        if (baselineHeight) {
          megaFeaturedReference.productHeight = baselineHeight;
          bannerOnlyPanels.forEach(panel => setPanelBannerHeight(panel, baselineHeight));
        }
      };

      if (isMacSafari) {
        applyBannerHeights({ useCache: true });
        return;
      }

      withAllMegaPanelsOpen(applyBannerHeights);
    };
    const syncActiveMegaPanelBannerHeight = (trigger) => {
      if (!desktopMegaMenuMq.matches || !trigger) return;
      const panel = trigger.querySelector('.js-navbar-group-featured-panel');
      if (!panel) return;
      const layout = panel.dataset.featuredLayout || '';
      // Mixed layouts stretch the banner via the grid; only banner-only panels need a measured height.
      if (isMixedFeaturedLayout(layout)) {
        clearPanelBannerHeights(panel);
        return;
      }
      if (!isBannerOnlyFeaturedLayout(layout)) return;
      clearPanelBannerHeights(panel);
      void panel.offsetHeight;
      const height = getBannerBaselineHeight();
      if (!height) return;
      setPanelBannerHeight(panel, height);
    };
    const getMegaMenuViewportCap = () => {
      const rootStyles = getComputedStyle(document.documentElement);
      const measuredHeaderHeight = parseFloat(rootStyles.getPropertyValue('--header-h'));
      const headerOffset = Number.isFinite(measuredHeaderHeight) ? measuredHeaderHeight : (navRow ? Math.round(navRow.getBoundingClientRect().bottom) : 90);
      // Match surface CSS: max-lg -5rem, lg+ -3rem
      const bottomGap = window.matchMedia('(min-width: 1024px)').matches ? 48 : 80;
      return Math.max(240, Math.floor(window.innerHeight - headerOffset - bottomGap));
    };
    const measureMegaMenuSurfaceOuterHeight = (surface) => {
      const previousInlineHeight = surface.style.height;
      const previousInlineMaxHeight = surface.style.maxHeight;
      surface.style.height = 'auto';
      surface.style.maxHeight = 'none';
      const surfaceStyles = getComputedStyle(surface);
      const borderTop = parseFloat(surfaceStyles.borderTopWidth) || 0;
      const borderBottom = parseFloat(surfaceStyles.borderBottomWidth) || 0;
      const measuredOuterHeight = Math.ceil(surface.scrollHeight + borderTop + borderBottom);
      surface.style.height = previousInlineHeight;
      surface.style.maxHeight = previousInlineMaxHeight;
      return measuredOuterHeight;
    };
    const setMegaMenuScrollLock = (locked) => {
      const root = document.documentElement;
      const scrollableSurface = activeMegaPanel && activeMegaPanel.querySelector('.js-mega-menu-scrollable');
      if (locked && megaMenuScrollLockMq.matches && scrollableSurface) {
        const scrollbarWidth = window.innerWidth - root.clientWidth;
        if (scrollbarWidth > 0) root.style.paddingRight = scrollbarWidth + 'px';
        root.classList.add('js-mega-menu-scroll-lock');
        return;
      }
      root.classList.remove('js-mega-menu-scroll-lock');
      root.style.removeProperty('padding-right');
    };

    const syncMegaMenuHeights = ({ forceFullMeasure = false } = {}) => {
      if (!desktopMegaMenuMq.matches) {
        megaMenuHeightPrimed = false;
        megaMenuHeightBaseline = 0;
        document.documentElement.style.removeProperty('--mega-menu-h');
        return;
      }

      const triggerList = Array.from(megaTriggers);
      if (!triggerList.length) {
        megaMenuHeightPrimed = false;
        megaMenuHeightBaseline = 0;
        document.documentElement.style.removeProperty('--mega-menu-h');
        return;
      }

      syncNavbarGroupFillPanelColumns();

      const viewportCap = getMegaMenuViewportCap();

      if (!forceFullMeasure && megaMenuHeightPrimed) {
        const cachedTargetHeight = Math.max(1, Math.min(megaMenuHeightBaseline, viewportCap));
        document.documentElement.style.setProperty('--mega-menu-h', cachedTargetHeight + 'px');
        return;
      }

      const previousOpenStates = triggerList.map(trigger => trigger.open);
      triggerList.forEach(trigger => { trigger.open = true; });
      syncNavbarGroupBannerHeights();

      let tallestSurfaceHeight = 0;
      document.querySelectorAll('.js-mega-menu-surface').forEach(surface => {
        const measuredOuterHeight = measureMegaMenuSurfaceOuterHeight(surface);
        tallestSurfaceHeight = Math.max(tallestSurfaceHeight, measuredOuterHeight);
      });

      triggerList.forEach((trigger, index) => { trigger.open = previousOpenStates[index]; });

      if (!tallestSurfaceHeight) {
        megaMenuHeightPrimed = false;
        megaMenuHeightBaseline = 0;
        document.documentElement.style.removeProperty('--mega-menu-h');
        return;
      }

      megaMenuHeightBaseline = tallestSurfaceHeight;
      megaMenuHeightPrimed = true;
      const targetHeight = Math.max(1, Math.min(megaMenuHeightBaseline, viewportCap));
      document.documentElement.style.setProperty('--mega-menu-h', targetHeight + 'px');
    };

    const scheduleMegaMenuHeightSync = ({ forceFullMeasure = false } = {}) => {
      if (megaHeightSyncFrame) cancelAnimationFrame(megaHeightSyncFrame);
      megaHeightSyncFrame = requestAnimationFrame(() => {
        megaHeightSyncFrame = null;
        if (isMacSafari) {
          document.documentElement.style.removeProperty('--mega-menu-h');
          syncActiveMegaPanelBannerHeight(activeMegaPanel);
          return;
        }
        syncMegaMenuHeights({ forceFullMeasure });
      });
    };

    const isMegaInteractiveTarget = (el) => {
      if (!el || !(el instanceof Element)) return false;
      return Boolean(el.closest('.js-mega-menu-item, .js-mega-menu-trigger'));
    };

    const openMegaMenu = (trigger) => {
      clearTimeout(megaHideTimeout);
      clearTimeout(megaShowTimeout);
      if (activeMegaPanel && activeMegaPanel !== trigger) activeMegaPanel.open = false;
      trigger.open = true;
      activeMegaPanel = trigger;
      setMegaMenuScrollLock(true);
      syncActiveMegaPanelBannerHeight(trigger);
      scheduleMegaMenuHeightSync({ forceFullMeasure: false });
    };
    const scheduleMegaOpen = (trigger) => {
      clearTimeout(megaHideTimeout);
      clearTimeout(megaShowTimeout);
      megaShowTimeout = setTimeout(() => openMegaMenu(trigger), megaOpenDelayMs);
    };
    const closeMegaMenu = () => {
      if (!activeMegaPanel) return;
      activeMegaPanel.open = false;
      activeMegaPanel = null;
      setMegaMenuScrollLock(false);
    };
    const scheduleMegaClose = (e) => {
      const nextTarget = e && e.relatedTarget;
      if (isMegaInteractiveTarget(nextTarget)) return;
      clearTimeout(megaShowTimeout);
      clearTimeout(megaHideTimeout);
      megaHideTimeout = setTimeout(closeMegaMenu, megaCloseDelayMs);
    };

    megaTriggers.forEach(trigger => {
      const item = getMegaMenuItem(trigger);
      item.addEventListener('mouseenter', () => {
        primeMegaMenuMeasurement();
        scheduleMegaOpen(trigger);
      });
      item.addEventListener('mouseleave', scheduleMegaClose);
      trigger.addEventListener('toggle', () => {
        if (!trigger.open || !desktopMegaMenuMq.matches) return;
        activeMegaPanel = trigger;
        setMegaMenuScrollLock(true);
        syncActiveMegaPanelBannerHeight(trigger);
        scheduleMegaMenuHeightSync({ forceFullMeasure: false });
      });
      const megaMenuSurface = trigger.querySelector('.js-mega-menu-surface');
      if (megaMenuSurface) {
        megaMenuSurface.addEventListener('mouseenter', () => {
          clearTimeout(megaHideTimeout);
          clearTimeout(megaShowTimeout);
        });
        megaMenuSurface.addEventListener('mouseleave', scheduleMegaClose);
      }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && activeMegaPanel) closeMegaMenu(); });
    document.addEventListener('click', (e) => { if (activeMegaPanel && !e.target.closest('.js-mega-menu-item, .js-mega-menu-trigger')) closeMegaMenu(); });

    // =============================================
    // 9. DESKTOP MEGA MENU SIZING
    //     Mega panels are pre-populated statically in the snippets,
    //     so we only keep the column/height sync helpers here.
    // =============================================
    syncNavbarGroupFillPanelColumns();

    // Defer the first (expensive) full mega-menu measurement until the user first
    // interacts with the nav. Opening every panel to measure on page load forces a
    // full layout of all mega panels; doing it on first hover/focus keeps the same
    // sizing behavior (incl. keyboard users) without the load-time cost.
    let megaMenuMeasurePrimed = false;
    const primeMegaMenuMeasurement = () => {
      if (megaMenuMeasurePrimed) return;
      megaMenuMeasurePrimed = true;
      syncNavbarGroupBannerHeights();
      scheduleMegaMenuHeightSync({ forceFullMeasure: true });
    };
    document.querySelectorAll('.js-navbar-group-featured-panel img').forEach(img => {
      if (img.complete) return;
      img.addEventListener('load', () => {
        syncNavbarGroupBannerHeights();
        if (activeMegaPanel) syncActiveMegaPanelBannerHeight(activeMegaPanel);
        scheduleMegaMenuHeightSync({ forceFullMeasure: true });
      }, { once: true });
    });
    const megaMenuNav = document.querySelector('#main-menu-drawer nav');
    if (megaMenuNav) {
      ['pointerenter', 'focusin'].forEach(evt => megaMenuNav.addEventListener(evt, primeMegaMenuMeasurement, { once: true, passive: true }));
    }
    window.addEventListener('resize', () => {
      syncNavbarGroupFillPanelColumns();
      scheduleMegaMenuHeightSync({ forceFullMeasure: true });
      setMegaMenuScrollLock(Boolean(activeMegaPanel));
    }, { passive: true });

    // =============================================
    // 10. DESKTOP NAV OVERFLOW
    //     Hides nav items that don't fit in the bar. Re-checks on resize.
    // =============================================
    const navBar = document.querySelector('#main-menu-drawer nav');
    let runDesktopNavOverflow = null;
    if (navBar) {
      runDesktopNavOverflow = () => {
        if (window.innerWidth < 768) {
          navBar.querySelectorAll('.js-mega-menu-item, .js-desktop-nav-item').forEach(item => {
            item.style.visibility = '';
            item.style.position = '';
            item.style.pointerEvents = '';
          });
          return;
        }
        const navRight = navBar.getBoundingClientRect().right;
        navBar.querySelectorAll('.js-mega-menu-item, .js-desktop-nav-item').forEach(item => {
          item.style.visibility = '';
          if (item.getBoundingClientRect().right > navRight + 1) { item.style.visibility = 'hidden'; item.style.position = 'absolute'; item.style.pointerEvents = 'none'; }
          else { item.style.position = ''; item.style.pointerEvents = ''; }
        });
      };
      runDesktopNavOverflow();
      window.addEventListener('resize', runDesktopNavOverflow, { passive: true });
    }

    // =============================================
    // 11. MOBILE SLIDE-PANEL NAVIGATION
    //     Opening a dropdown hides siblings and slides its children in from the right.
    //     Back button reverses it. When the drawer closes, everything resets.
    //     The children div lives outside the <details> for desktop compatibility.
    // =============================================
    const mqlMd = window.matchMedia('(min-width: 768px)');
    const drawer = document.getElementById('main-menu-drawer');
    const getWrapper = (el) => el.closest('.js-nav-item') || el;
    const findChildrenDiv = (details) => {
      const wrapper = getWrapper(details);
      const inWrapper = Array.from(wrapper.children).find(child => child.classList && child.classList.contains('js-mobile-dropdown-children'));
      if (inWrapper) return inWrapper;
      let sibling = details.nextElementSibling;
      while (sibling) {
        if (sibling.classList && sibling.classList.contains('js-mobile-dropdown-children')) return sibling;
        sibling = sibling.nextElementSibling;
      }
      return null;
    };

    const toggleSiblings = (wrapper, hide) => {
      const parent = wrapper.parentElement;
      if (!parent) return;
      const isPrimaryMobileMenuItem = (el) => {
        if (!el) return false;
        if (el.matches('details.js-mobile-dropdown, a.js-desktop-nav-item, a.js-mobile-nav-leaf')) return true;
        return Boolean(el.querySelector('details.js-mobile-dropdown, a.js-desktop-nav-item, a.js-mobile-nav-leaf'));
      };
      Array.from(parent.children).forEach(child => {
        if (child === wrapper) return;
        if (!isPrimaryMobileMenuItem(child)) return;
        if (hide && !child.classList.contains('tw:hidden')) { child.dataset.mobileHid = '1'; child.classList.add('tw:hidden'); }
        else if (!hide && child.dataset.mobileHid === '1') { child.classList.remove('tw:hidden'); delete child.dataset.mobileHid; }
      });
    };
    const setMobileHiddenState = (el, hide) => {
      if (!el) return;
      if (hide && !el.classList.contains('tw:hidden')) {
        el.dataset.mobileHid = '1';
        el.classList.add('tw:hidden');
      } else if (!hide && el.dataset.mobileHid === '1') {
        el.classList.remove('tw:hidden');
        delete el.dataset.mobileHid;
      }
    };
    const toggleOtherMobileHeaders = (activeChildren, hide) => {
      if (!menuContainer) return;
      menuContainer.querySelectorAll('.js-mobile-dropdown-children > .js-mobile-submenu-header').forEach(header => {
        if (activeChildren && activeChildren.contains(header)) return;
        setMobileHiddenState(header, hide);
      });
    };
    const isHiddenInMobileTree = (el, stopAt) => {
      let current = el;
      while (current && current !== stopAt) {
        if (current.classList && current.classList.contains('tw:hidden')) return true;
        current = current.parentElement;
      }
      return false;
    };
    const findSingleAutoSkipSubgroup = (children) => {
      if (!children) return null;
      const subgroupCandidates = Array.from(children.querySelectorAll('details.js-mobile-subgroup'))
        .filter(subgroup => subgroup.closest('.js-mobile-dropdown-children') === children)
        .filter(subgroup => !isHiddenInMobileTree(subgroup, children));
      if (subgroupCandidates.length !== 1) return null;

      const subgroup = subgroupCandidates[0];
      const visiblePeerSubgroups = subgroupCandidates.filter(candidate => candidate !== subgroup);
      if (visiblePeerSubgroups.length) return null;
      return subgroup;
    };
    const setAutoSkipSubgroupMarker = (children) => {
      if (!children) return null;
      children.querySelectorAll('details.js-mobile-subgroup[data-mobile-auto-skip="1"]')
        .forEach(subgroup => delete subgroup.dataset.mobileAutoSkip);
      const subgroup = findSingleAutoSkipSubgroup(children);
      if (!subgroup) return null;
      subgroup.dataset.mobileAutoSkip = '1';
      return subgroup;
    };
    const isAutoSkipSubgroupPath = (subgroup) => {
      if (!subgroup) return false;
      return subgroup.dataset.mobileAutoSkip === '1';
    };

    const slideIn = (el) => {
      if (!el) return;
      el.classList.remove('tw:translate-x-0', 'tw:opacity-100');
      el.classList.add('tw:translate-x-3/4', 'tw:opacity-0');
      el.classList.remove('tw:hidden');
      requestAnimationFrame(() => { el.classList.remove('tw:translate-x-3/4', 'tw:opacity-0'); el.classList.add('tw:translate-x-0', 'tw:opacity-100'); });
    };
    const hideAndResetSlideState = (el) => {
      if (!el) return;
      el.classList.add('tw:hidden');
      el.classList.remove('tw:translate-x-0', 'tw:opacity-100');
      el.classList.add('tw:translate-x-3/4', 'tw:opacity-0');
    };
    const slideOut = (el, cb) => {
      if (!el) { if (cb) cb(); return; }
      el.classList.remove('tw:translate-x-0', 'tw:opacity-100');
      el.classList.add('tw:translate-x-3/4', 'tw:opacity-0');
      el.addEventListener('transitionend', () => { if (cb) cb(); }, { once: true });
      setTimeout(() => { if (cb) cb(); }, 350);
    };

    document.querySelectorAll('details.js-mobile-dropdown:not(.js-mobile-expanded)').forEach(d => {
      d.addEventListener('toggle', () => {
        const children = findChildrenDiv(d);
        if (mqlMd.matches) return;
        if (d.open) {
          toggleSiblings(getWrapper(d), true);
          toggleOtherMobileHeaders(children, true);
          if (drawer) drawer.scrollTop = 0;
          if (children) {
            children.dataset.mobileHid = '';
            slideIn(children);
            const matchingSubgroup = setAutoSkipSubgroupMarker(children);
            if (matchingSubgroup && !matchingSubgroup.open) matchingSubgroup.open = true;
          }
        } else {
          hideAndResetSlideState(children);
          toggleOtherMobileHeaders(children, false);
          toggleSiblings(getWrapper(d), false);
        }
      });
    });

    // Hides/shows all items within a dropdown when a subgroup opens/closes.
    // Walks top-level children of the dropdown container so it works
    // across Navbar Group boundaries (Submenu Groups nested inside them).
    const toggleDropdownSubgroups = (activeDetails, hide) => {
      const container = activeDetails.closest('.js-mobile-dropdown-children');
      if (!container) { toggleSiblings(getWrapper(activeDetails), hide); return; }
      Array.from(container.children).forEach(child => {
        if (child.contains(activeDetails)) {
          const ngc = child.querySelector('.js-navbar-group-children');
          if (ngc) {
            Array.from(ngc.children).forEach(ngcChild => {
              if (ngcChild.contains(activeDetails)) return;
              setMobileHiddenState(ngcChild, hide);
            });
          }
        } else {
          setMobileHiddenState(child, hide);
        }
      });
    };

    document.querySelectorAll('details.js-mobile-subgroup').forEach(d => {
      d.addEventListener('toggle', () => {
        if (mqlMd.matches || !d.open) return;
        toggleDropdownSubgroups(d, true);
        if (drawer) drawer.scrollTop = 0;
        slideIn(d.querySelector('.js-mobile-subgroup-panel'));
      });
    });

    document.querySelectorAll('.js-mobile-back').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const subgroup = btn.closest('details.js-mobile-subgroup');
        if (subgroup) {
          const shouldCloseParentDropdown = isAutoSkipSubgroupPath(subgroup);
          let done = false;
          slideOut(subgroup.querySelector('.js-mobile-subgroup-panel'), () => {
            if (done) return; done = true;
            toggleDropdownSubgroups(subgroup, false);
            subgroup.open = false;
            if (!shouldCloseParentDropdown) return;
            const children = subgroup.closest('.js-mobile-dropdown-children');
            const wrapper = children ? children.closest('.js-nav-item') : null;
            const dropdown = wrapper ? wrapper.querySelector('details.js-mobile-dropdown') : null;
            if (!dropdown) return;
            let parentDone = false;
            slideOut(children, () => {
              if (parentDone) return; parentDone = true;
              hideAndResetSlideState(children);
              toggleOtherMobileHeaders(children, false);
              toggleSiblings(getWrapper(dropdown), false);
              dropdown.open = false;
            });
          });
          return;
        }
        const navItem = btn.closest('.js-nav-item');
        const dropdown =
          btn.closest('details.js-mobile-dropdown')
          || (navItem && navItem.querySelector('details.js-mobile-dropdown'));
        if (!dropdown) return;
        const children = findChildrenDiv(dropdown);
        let done = false;
        slideOut(children, () => {
          if (done) return; done = true;
          hideAndResetSlideState(children);
          toggleOtherMobileHeaders(children, false);
          toggleSiblings(getWrapper(dropdown), false);
          dropdown.open = false;
        });
      });
    });

    if (menuContainer) {
      new MutationObserver(() => {
        if (!menuContainer.classList.contains('tw:hidden') || mqlMd.matches) return;
        resetMobileMenuState();
      }).observe(menuContainer, { attributes: true, attributeFilter: ['class'] });
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-guide-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('show-more-less-content')) {
    class ShowMoreLessContent extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('#toggle-content');
        const contentEl = this.querySelector('#content');
        if (!contentEl) return;
        const fullHeight = contentEl.offsetHeight;
        const markReady = () => this.classList.add('ready');
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', markReady);
        } else {
          markReady();
        }

        let minHeight = this.getAttribute('min-height-mobile') ? this.getAttribute('min-height-mobile') - 20 : 0;
        if (window.screen.width > 767) {
          minHeight = this.getAttribute('min-height-desktop') ? this.getAttribute('min-height-desktop') - 20 : 0;
        }

        if (fullHeight > minHeight && minHeight > 0) {
          this.classList.add('toggle');
        }

        if (!button) return;
        button.addEventListener('click', this.toggleContent.bind(this));
      }

      toggleContent() {
        const contentEl = this.querySelector('#content');
        if (!contentEl) return;

        if (this.hasAttribute('open')) {
          if (contentEl.scrollHeight > 1000) {
            window.scrollTo({
              top: contentEl.getBoundingClientRect().top + window.scrollY - 100,
            });
          }
          if (contentEl.style.maxHeight === 'none') {
            contentEl.style.maxHeight = contentEl.scrollHeight + 'px';
          }
          const element = this;
          setTimeout(function () {
            element.removeAttribute('open');
            contentEl.style.maxHeight = 'revert-layer';
          }, 350);
        } else {
          this.setAttribute('open', '');
          contentEl.style.maxHeight = contentEl.scrollHeight + 'px';
          const element = this;
          contentEl.addEventListener('transitionend', function onEnd(event) {
            if (event.propertyName && event.propertyName !== 'max-height') return;
            contentEl.removeEventListener('transitionend', onEnd);
            if (element.hasAttribute('open')) {
              contentEl.style.maxHeight = 'none';
            }
          });
        }
      }
    }

    customElements.define('show-more-less-content', ShowMoreLessContent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
function initRecScrollArrows(scrollEl) {
  var wrapper = scrollEl.closest('.js-rec-scroll-wrapper');
  if (!wrapper) return;
  var left = wrapper.querySelector('.js-rec-arrow-left');
  var right = wrapper.querySelector('.js-rec-arrow-right');
  if (!left || !right) return;

  function step() {
    var card = scrollEl.querySelector('.recommended-product');
    return card ? card.offsetWidth + (parseInt(getComputedStyle(scrollEl).gap) || 12) : 300;
  }

  right.addEventListener('click', function() { scrollEl.scrollBy({ left: step(), behavior: 'smooth' }); });
  left.addEventListener('click', function() { scrollEl.scrollBy({ left: -step(), behavior: 'smooth' }); });

  var mql = window.matchMedia('(min-width: 1024px)');

  function updateArrows() {
    if (mql.matches) {
      left.style.display = 'none';
      right.style.display = 'none';
      return;
    }
    var noOverflow = scrollEl.scrollWidth <= scrollEl.clientWidth + 5;
    left.style.display = (noOverflow || scrollEl.scrollLeft <= 5) ? 'none' : 'flex';
    var atEnd = scrollEl.scrollLeft + scrollEl.clientWidth >= scrollEl.scrollWidth - 5;
    right.style.display = noOverflow ? 'none' : 'flex';
    right.style.opacity = atEnd ? '0.3' : '1';
  }

  scrollEl.addEventListener('scroll', updateArrows);
  mql.addEventListener('change', updateArrows);
  updateArrows();
}

function initStaticCartRecs() {
  document.querySelectorAll('[data-static-recs]').forEach(function(scrollEl) {
    if (!scrollEl.querySelector('.recommended-product')) return;

    if (window.slideUpCart) {
      window.slideUpCart.interceptAddToCartForms();
    }

    initRecScrollArrows(scrollEl);
  });
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      const urls = this.dataset.urls.split(',');
      const fetchPromises = urls.map(url => fetch(url).then(response => response.text()));

      Promise.all(fetchPromises)
        .then(responses => {
          const maxProducts = 12;
          const productIds = new Set();
          const productHtmlList = [];

          responses.forEach((response) => {
            if (productHtmlList.length >= maxProducts) return;

            const html = document.createElement('div');
            html.innerHTML = response;

            html.querySelectorAll('.recommended-product').forEach((product) => {
              if (productHtmlList.length >= maxProducts) return;

              const productId = product.dataset.productId;
              if (!productIds.has(productId)) {
                productIds.add(productId);
                productHtmlList.push(product.outerHTML);
              }
            });
          });

          const recommendationsHtml = productHtmlList.join('');

          if (recommendationsHtml.trim().length) {
            this.innerHTML = recommendationsHtml;

            if (window.slideUpCart) {
              window.slideUpCart.interceptAddToCartForms();
            }

            initRecScrollArrows(this);
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

window.initStaticCartRecs = initStaticCartRecs;
initStaticCartRecs();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2_trustpilot"] && !Shopify.designMode) return;
  try {
    
  function trustpilotWidgets() {
    return document.getElementsByClassName('trustpilot-widget');
  }

  function cleanTrustpilotWidgets() {
    var section = document.querySelector('.js-trustpilot-section');
    if (!section || section.getAttribute('data-clean-widgets') !== 'true') return;
    var widgets = trustpilotWidgets();
    for (var i = 0; i < widgets.length; i++) {
      var widget = widgets[i];
      while (widget.firstChild && widget.firstChild.tagName !== 'IFRAME') {
        widget.removeChild(widget.firstChild);
      }
    }
  }

  function applyTrustpilotWidgets() {
    if (!window.Trustpilot || !window.Trustpilot.loadFromElement) return;
    var widgets = trustpilotWidgets();
    for (var i = 0; i < widgets.length; i++) {
      if (widgets[i].querySelector('iframe')) continue;
      window.Trustpilot.loadFromElement(widgets[i], true);
    }
  }

  function loadTrustpilot() {
    if (!document.querySelector('.js-trustpilot-section')) return;
    cleanTrustpilotWidgets();
    if (window.Trustpilot && window.Trustpilot.loadFromElement) {
      applyTrustpilotWidgets();
      return;
    }
    var existing = document.querySelector('script[src*="widget.trustpilot.com/bootstrap"]');
    if (existing) {
      existing.addEventListener('load', applyTrustpilotWidgets);
      applyTrustpilotWidgets();
      return;
    }
    var script = document.createElement('script');
    script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    script.async = true;
    script.setAttribute('data-dynamic', 'true');
    script.addEventListener('load', applyTrustpilotWidgets);
    document.head.appendChild(script);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadTrustpilot);
  } else {
    loadTrustpilot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.classList.contains('section-trustpilot-v2')) {
      loadTrustpilot();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
